// @flow
import Enum from 'common/enums/Enum';

export const EventKeyEnum = new Enum({
    ArrowDown: 'ArrowDown',
    ArrowUp: 'ArrowUp',
    Escape: 'Escape',
    Enter: 'Enter',
    Tab: 'Tab'
});

export const DomInputTypeEnum = new Enum({
    Text: 'text',
    Password: 'password'
});
